/* Skill Toss launcher: a floating button on every page, a once-a-visit invite,
 * and deep links (#skill-toss or ?play=skill-toss). Opens the game in a modal.
 * The game's own CSS, JS and font load only when someone opens it.
 * Also draws the floating WhatsApp button, bottom left.
 * Oct 2026 audit: earthy colours instead of neon green; on phones the button is a
 * small ball that appears only after the first scroll; hidden on product pages,
 * where the sticky Add to cart bar owns the bottom of the screen.
 */
(function () {
  'use strict';
  var cfgEl = document.getElementById('mm-st-config');
  if (!cfgEl) return;
  var CFG; try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (/^\/(cart|checkout|account)/.test(location.pathname)) return;

  var store = {
    get: function (k, s) { try { return (s ? sessionStorage : localStorage).getItem(k); } catch (e) { return null; } },
    set: function (k, v, s) { try { (s ? sessionStorage : localStorage).setItem(k, v); } catch (e) {} }
  };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isPhone = window.matchMedia && matchMedia('(max-width: 749px)').matches;
  var isProduct = /^\/products\//.test(location.pathname);
  var loaded = null, modal = null, lastFocus = null;

  function css() {
    if (document.getElementById('mm-stl-css')) return;
    var s = document.createElement('style');
    s.id = 'mm-stl-css';
    s.textContent =
      '.mm-stl{position:fixed;right:max(16px,env(safe-area-inset-right));bottom:max(16px,env(safe-area-inset-bottom));z-index:60;display:flex;align-items:center;gap:10px;padding:8px 18px 8px 8px;border:2px solid #3d1c00;border-radius:999px;background:#ffddc1;color:#3d1c00;font:700 15px/1.1 var(--font-body--family,Quicksand,sans-serif);box-shadow:4px 4px 0 #3d1c00;cursor:pointer;transform:translateY(140%);transition:transform .45s cubic-bezier(.3,1.4,.5,1),box-shadow .15s ease}' +
      '.mm-stl.is-in{transform:none}.mm-stl:hover{box-shadow:6px 6px 0 #3d1c00;transform:translateY(-2px)}.mm-stl:focus-visible{outline:3px solid #3d1c00;outline-offset:3px}' +
      '.mm-stl__ball{width:36px;height:36px;flex:none;border-radius:46% 54% 50% 50%/52% 48% 54% 46%;border:2px solid #3d1c00;background:linear-gradient(118deg,transparent 44%,rgba(61,28,0,.25) 45% 48%,transparent 49%),linear-gradient(32deg,transparent 54%,rgba(61,28,0,.2) 55% 58%,transparent 59%),#fff;animation:mm-stl-bob 2.6s ease-in-out infinite}' +
      '@keyframes mm-stl-bob{50%{transform:translateY(-3px) rotate(-12deg)}}' +
      '.mm-stl__t small{display:block;font-weight:600;font-size:12px;opacity:.8}' +
      '.mm-wa{position:fixed;left:max(16px,env(safe-area-inset-left));bottom:max(16px,env(safe-area-inset-bottom));z-index:60;display:grid;place-items:center;width:52px;height:52px;border-radius:50%;background:#25d366;color:#fff;box-shadow:0 4px 14px rgba(0,0,0,.22);text-decoration:none}' +
      '.mm-wa:focus-visible{outline:3px solid #3d1c00;outline-offset:3px}.mm-wa svg{width:28px;height:28px}' +
      '.mm-stt{position:fixed;right:max(16px,env(safe-area-inset-right));bottom:calc(max(16px,env(safe-area-inset-bottom)) + 70px);z-index:61;width:min(320px,calc(100vw - 32px));padding:16px 16px 14px;border:2px solid #3d1c00;border-radius:18px;background:#fff;color:#3d1c00;box-shadow:6px 6px 0 #ffd700;font:500 15px/1.45 var(--font-body--family,Quicksand,sans-serif);opacity:0;transform:translateY(12px);transition:opacity .3s ease,transform .3s ease;pointer-events:none}' +
      '.mm-stt.is-in{opacity:1;transform:none;pointer-events:auto}.mm-stt b{display:block;font:700 22px/1 var(--font-heading--family,Oswald,sans-serif);text-transform:uppercase;color:#000;margin-bottom:6px}' +
      '.mm-stt__row{display:flex;gap:8px;margin-top:12px}.mm-stt__row button{flex:1;min-height:42px;border-radius:999px;border:2px solid #3d1c00;font:700 14px/1 var(--font-body--family,Quicksand,sans-serif);cursor:pointer}' +
      '.mm-stt__go{background:#3d1c00;color:#ffddc1}.mm-stt__no{background:#fff;color:#3d1c00}' +
      '.mm-stm{position:fixed;inset:0;z-index:100;display:grid;place-items:start center;overflow-y:auto;padding:24px 12px;background:rgba(30,18,0,.55);opacity:0;transition:opacity .25s ease}' +
      '.mm-stm.is-in{opacity:1}.mm-stm__panel{position:relative;width:min(1180px,100%);border:2px solid #3d1c00;border-radius:24px;background:#fff;box-shadow:10px 10px 0 #ffd700;transform:translateY(24px) scale(.98);transition:transform .35s cubic-bezier(.3,1.3,.5,1)}' +
      '.mm-stm.is-in .mm-stm__panel{transform:none}' +
      '.mm-stm__x{position:absolute;top:14px;right:14px;z-index:5;width:44px;height:44px;border-radius:50%;border:2px solid #3d1c00;background:#fff;color:#3d1c00;font:700 22px/1 sans-serif;cursor:pointer;box-shadow:3px 3px 0 #3d1c00}' +
      '.mm-stm__x:focus-visible{outline:3px solid #3d1c00;outline-offset:3px}.mm-stm__load{padding:80px 20px;text-align:center;font:700 16px var(--font-body--family,Quicksand,sans-serif);color:#3d1c00}' +
      'html.mm-stm-open{overflow:hidden}html.mm-stm-open .mm-stl,html.mm-stm-open .mm-stt,html.mm-stm-open .mm-wa{display:none}' +
      '@media (max-width:749px){.mm-stl{padding:5px;gap:0;box-shadow:3px 3px 0 #3d1c00}.mm-stl__ball{width:30px;height:30px}.mm-stl__t{position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap}.mm-wa{width:46px;height:46px}.mm-wa--lift{bottom:calc(max(16px,env(safe-area-inset-bottom)) + 76px)}}' +
      '@media (max-width:600px){.mm-stm{padding:0}.mm-stm__panel{border-radius:0;border-width:0;min-height:100%;box-shadow:none}.mm-stm__x{top:10px;right:10px}}' +
      '@media (prefers-reduced-motion:reduce){.mm-stl__ball{animation:none}.mm-stl,.mm-stt,.mm-stm,.mm-stm__panel{transition:none}}' +
      '@media print{.mm-stl,.mm-stt,.mm-wa{display:none!important}.mm-stm{position:static;background:none;padding:0}.mm-stm__panel{box-shadow:none;border:0}}';
    document.head.appendChild(s);
  }

  function load() {
    if (loaded) return loaded;
    function add(tag, attrs) { return new Promise(function (res, rej) { var el = document.createElement(tag); for (var k in attrs) el.setAttribute(k, attrs[k]); el.onload = res; el.onerror = rej; document.head.appendChild(el); }); }
    var font = document.createElement('link'); font.rel = 'stylesheet'; font.href = CFG.font; document.head.appendChild(font);
    loaded = Promise.all([
      add('link', { rel: 'stylesheet', href: CFG.css }),
      window.MMForm ? Promise.resolve() : add('script', { src: CFG.form }),
      window.MMSkillToss ? Promise.resolve() : add('script', { src: CFG.js })
    ]);
    return loaded;
  }

  function track(name) { try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, { page: location.pathname }); } catch (e) {} }

  function open(source) {
    hideTeaser(true);
    if (modal) return;
    css();
    lastFocus = document.activeElement;
    modal = document.createElement('div');
    modal.className = 'mm-stm';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Skill Toss game');
    modal.innerHTML = '<div class="mm-stm__panel"><button type="button" class="mm-stm__x" aria-label="Close the game">×</button><div class="mm-stm__body"><p class="mm-stm__load">Getting the paper balls ready…</p></div></div>';
    document.body.appendChild(modal);
    document.documentElement.classList.add('mm-stm-open');
    requestAnimationFrame(function () { modal.classList.add('is-in'); });
    modal.querySelector('.mm-stm__x').addEventListener('click', close);
    modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
    modal.querySelector('.mm-stm__x').focus();
    track('mm_st_open');
    store.set('mm_st_seen', '1', true);
    load().then(function () {
      if (!modal) return;
      var body = modal.querySelector('.mm-stm__body');
      body.innerHTML = '';
      window.MMSkillToss.mount(body, CFG, { inModal: true, source: source || 'modal' });
    }).catch(function () {
      if (modal) modal.querySelector('.mm-stm__body').innerHTML = '<p class="mm-stm__load">The game didn’t load. Check your connection and try again.</p>';
    });
  }

  function close() {
    if (!modal) return;
    var m = modal; modal = null;
    m.classList.remove('is-in');
    document.documentElement.classList.remove('mm-stm-open');
    setTimeout(function () { m.remove(); }, reduce ? 0 : 250);
    if (location.hash === '#skill-toss') history.replaceState(null, '', location.pathname + location.search);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('keydown', function (e) {
    if (!modal) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') { // keep focus inside the game
      var f = modal.querySelectorAll('button, a[href], input, select, [tabindex]:not([tabindex="-1"])');
      if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  // Any link to #skill-toss opens the game, on any page.
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#skill-toss"], [data-mm-st-open]');
    if (!a) return;
    e.preventDefault();
    open('link');
  });
  window.addEventListener('hashchange', function () { if (location.hash === '#skill-toss') open('hash'); });

  // Floating WhatsApp button, bottom left, on every page
  function whatsapp() {
    if (!CFG.wa) return;
    css();
    var a = document.createElement('a');
    a.className = 'mm-wa' + (isProduct ? ' mm-wa--lift' : '');
    a.href = 'https://wa.me/' + CFG.wa + '?text=' + encodeURIComponent('Hi Mitti & Mor, I have a question about ' + document.title);
    a.target = '_blank';
    a.rel = 'noopener noreferrer';
    a.setAttribute('aria-label', 'Chat with us on WhatsApp');
    a.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.08-.3-.15-1.26-.46-2.39-1.48-.88-.79-1.48-1.76-1.65-2.06-.17-.3-.02-.46.13-.6.13-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.07 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49.71.31 1.26.49 1.7.63.71.23 1.36.2 1.87.12.57-.09 1.76-.72 2-1.41.25-.7.25-1.29.18-1.41-.08-.13-.28-.2-.57-.35M12.05 21.79h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26c0-5.45 4.44-9.88 9.89-9.88 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.44 9.88-9.88 9.88M20.46 3.49A11.82 11.82 0 0 0 12.05 0C5.5 0 .16 5.34.16 11.89c0 2.1.55 4.14 1.59 5.95L.06 24l6.3-1.65a11.88 11.88 0 0 0 5.68 1.45h.01c6.55 0 11.89-5.34 11.89-11.89 0-3.18-1.24-6.16-3.48-8.42"/></svg>';
    document.body.appendChild(a);
  }

  // Floating Skill Toss button and the once-a-visit invite
  var btn, teaser;
  function launcher() {
    if (isProduct) return;
    css();
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mm-stl';
    btn.setAttribute('aria-label', 'Play Skill Toss, a 60 second game');
    btn.innerHTML = '<span class="mm-stl__ball" aria-hidden="true"></span><span class="mm-stl__t">Play Skill Toss<small>60 seconds, 3 paper balls</small></span>';
    btn.addEventListener('click', function () { open('launcher'); });
    document.body.appendChild(btn);
    if (!isPhone) { setTimeout(function () { btn.classList.add('is-in'); }, 50); return; }
    // On phones, keep the hero and its buttons clear until the visitor scrolls.
    function reveal() {
      if (window.scrollY < 600) return;
      btn.classList.add('is-in');
      window.removeEventListener('scroll', reveal);
    }
    window.addEventListener('scroll', reveal, { passive: true });
    reveal();
  }
  function showTeaser() {
    if (modal || isProduct || store.get('mm_st_seen', true) || store.get('mm_st_teased', true)) return;
    var until = +store.get('mm_st_snooze') || 0;
    if (Date.now() < until) return;
    store.set('mm_st_teased', '1', true);
    teaser = document.createElement('div');
    teaser.className = 'mm-stt';
    teaser.setAttribute('role', 'dialog');
    teaser.setAttribute('aria-label', 'Invitation to play Skill Toss');
    teaser.innerHTML = '<b>Got a minute?</b>Help your child throw 3 paper balls at the skills school skips. You get a report card at the end.<div class="mm-stt__row"><button type="button" class="mm-stt__go">Play now</button><button type="button" class="mm-stt__no">Not now</button></div>';
    document.body.appendChild(teaser);
    requestAnimationFrame(function () { teaser.classList.add('is-in'); });
    teaser.querySelector('.mm-stt__go').addEventListener('click', function () { open('teaser'); });
    teaser.querySelector('.mm-stt__no').addEventListener('click', function () { hideTeaser(); store.set('mm_st_snooze', String(Date.now() + 7 * 864e5)); });
  }
  function hideTeaser(now) {
    if (!teaser) return;
    var t = teaser; teaser = null;
    t.classList.remove('is-in');
    setTimeout(function () { t.remove(); }, now ? 0 : 300);
  }

  function start() {
    whatsapp();
    var inline = document.querySelector('[data-mm-st-inline]');
    if (inline) { // the /pages/skill-toss page plays inline
      load().then(function () { window.MMSkillToss.mount(inline, CFG, { inModal: false, source: 'page' }); });
      return;
    }
    launcher();
    var q = new URLSearchParams(location.search);
    if (location.hash === '#skill-toss' || q.get('play') === 'skill-toss') { open('deeplink'); return; }
    var views = (+store.get('mm_st_views', true) || 0) + 1;
    store.set('mm_st_views', String(views), true);
    setTimeout(showTeaser, views > 1 ? 6000 : 25000);
  }
  window.MMSkillTossLauncher = { open: open, close: close };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
